import React, {Fragment} from "react";
import styles from './Header.module.css'
import logo from '../Assets/HT logo round.png';
const Header = (props) => {
    return (
      <Fragment>
        <div className={styles.content}>
          <div className={styles.intro}>
            <img className={styles.ht} alt="HT logo" src={logo}></img>
            {props.intro}
          </div>

          <p className={styles.main}>{props.main}</p>
          
        </div>
      </Fragment>
    );
}

export default Header;